/* eslint-disable @typescript-eslint/no-explicit-any */
import { isAxiosError } from 'axios';
import hwAxios from '../../../rmsReduxStore/api-service/HWAxios';
import { acCustomerTypes } from '../acReduxExports';
import { ICustomerForm } from '../../../components/customerManagement/CustomerForm/CustomerForm';


const url = process.env.REACT_APP_SERVER_BASE_URL_AC;

// TODO: Customers List API
export const fetchAcCustomersData: any = (reqBody: unknown) => async (dispatch: (arg0: Partial<CustomerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcCustomerAction> = {
      type: acCustomerTypes.SET_AC_CUSTOMER_LOADER,
      loader: true
    }
    dispatch(loaderStartAction);
    const response = await hwAxios.post(url + '/customers/summary', reqBody)
    const action: Partial<AcCustomerAction> = {
      type: acCustomerTypes.FETCH_AC_CUSTOMERS_DATA,
      customers: response.data?.data?.customers,
      customerCount: response.data?.data?.customersCount,
    }
    dispatch(action)
    if (response?.status === 200) {
      const loaderEndAction: Partial<AcCustomerAction> = {
        type: acCustomerTypes.SET_AC_CUSTOMER_LOADER,
        loader: false
      }
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcCustomerAction> = {
      type: acCustomerTypes.SET_AC_CUSTOMER_LOADER,
      loader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}



export const setAcCustomerTableProps: any = (data, screen) => (dispatch: (arg0: Partial<AcCustomerAction>) => void) => {
  if (screen === 'customersList') {
    const action = {
      type: acCustomerTypes.SET_AC_CUSTOMER_LIST_TABLE_PROPS,
      customerListTableProps: data,
    };
    dispatch(action);
  } else if (screen === 'chargerList') {
    const action: Partial<AcCustomerAction> = {
      type: acCustomerTypes.SET_AC_CUSTOMER_CHARGER_LIST_TABLE_PROPS,
      customerChargerListTableProps: data,
    };
    dispatch(action);
  } else if (screen === 'editHistoryList') {
    const action: Partial<AcCustomerAction> = {
      type: acCustomerTypes.SET_AC_CUSTOMER_UPDATE_HISTORY_LIST_TABLE_PROPS,
      historyRecordTableProps: data,
    };
    dispatch(action);
  }
}


export const exportToCsvForAcCustomerList: any = (reqParams: unknown) => async () => {
  try {
    const { data, status } = await hwAxios.post(url + '/customers/summary/export', reqParams)
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      }
    }
  }
}


export const createAcCustomer: any = (reqBody: ICustomerForm) => async () => {
  try {
    const { data, status } = await hwAxios.post(url + '/customer', reqBody)
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      }
    }
  }
}

export const updateAcCustomer: any = (reqBody: unknown) => async () => {
  try {
    const { data, status } = await hwAxios.put(url + '/customer', reqBody)
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      }
    }
  }
}


export const fetchAcCustomerChargersData: any = (reqBody: unknown) => async (dispatch: (arg0: Partial<AcCustomerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcCustomerAction> = {
      type: acCustomerTypes.SET_AC_CUSTOMER_LOADER,
      loader: true
    }
    dispatch(loaderStartAction);

    const response = await hwAxios.post(url + '/chargers', reqBody)
    const action: Partial<AcChargerAction> = {
      type: acCustomerTypes.FETCH_AC_CUSTOMER_CHARGERS_DATA,
      chargers: response.data?.data?.chargers,
      chargerCount: response.data?.data?.chargerCount,
    }
    dispatch(action)
    if (response?.status === 200) {
      const loaderEndAction: Partial<AcCustomerAction> = {
        type: acCustomerTypes.SET_AC_CUSTOMER_LOADER,
        loader: false
      }
      dispatch(loaderEndAction);
    }

  } catch (error) {
    console.error(error)
    const loaderEndAction: Partial<AcCustomerAction> = {
      type: acCustomerTypes.SET_AC_CUSTOMER_LOADER,
      loader: false
    }
    dispatch(loaderEndAction);
    throw error
  }
}

export const fetchIndividualAcCustomerDetail: any = (reqParams: unknown) => async (dispatch: (arg0: Partial<AcCustomerAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcCustomerAction> = {
      type: acCustomerTypes.SET_AC_CUSTOMER_DETAIL_LOADER,
      individualCustomerDetailLoader: true
    }
    dispatch(loaderStartAction);
    const response = await hwAxios.get( url + '/customer', { params: reqParams })
    const action: Partial<AcCustomerAction> = {
      type: acCustomerTypes.FETCH_AC_CUSTOMER_DETAIL_DATA,
      individualCustomerDetail: response?.data?.data?.customer
    }
    dispatch(action)
    if (response?.status === 200) {
      const loaderEndAction: Partial<AcCustomerAction> = {
        type: acCustomerTypes.SET_AC_CUSTOMER_DETAIL_LOADER,
        individualCustomerDetailLoader: false
      }
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcCustomerAction> = {
      type: acCustomerTypes.SET_AC_CUSTOMER_DETAIL_LOADER,
      individualCustomerDetailLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}


export const deleteAcCustomer: any = (reqBody: unknown) => async () => {
  try {
    const { data, status } = await hwAxios.delete(url + '/customer', { data: reqBody })
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      }
    }
  }
}